module.exports = __webpack_public_path__ + "static/media/BikeSharing-retro5.a670e1fa.pdf";